"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceExchangeRateEditor = class UcInvoiceExchangeRateEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    currency;
    onCurrency(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("currency");
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    labelAlign;
    item;
    async $$load_item() {
        return _.extend({
            currency_to: null,
            value: 1,
            date: this.$fn.today(),
            bank: null
        }, this.value, { currency_from: this.currency });
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    triggerButtonID;
    async $$load_triggerButtonID() {
        return this.$fn.randomElementId();
    }
    currentTitle;
    async $$load_currentTitle() {
        return this.$fn.gettext('Exchange rate') + ' - ' + this.currency;
    }
    ux;
    dataMembers = ['labelAlign', 'item', 'formId', 'currencies', 'triggerButtonID', 'currentTitle', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                item: null,
                formId: null,
                currencies: null,
                triggerButtonID: null,
                currentTitle: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7242 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7241 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7242,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7241],
        });
        return {
            act_7315092382398562_reloadComponentData_7242,
            evh_7315092382398562_reload_7241,
            evh_7315092382398562_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceExchangeRateEditor.prototype, "currency", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('currency'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceExchangeRateEditor.prototype, "onCurrency", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceExchangeRateEditor.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceExchangeRateEditor.prototype, "onValue", null);
UcInvoiceExchangeRateEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceExchangeRateEditor);
exports.default = UcInvoiceExchangeRateEditor;
vue_property_decorator_1.Vue.component("UcInvoiceExchangeRateEditor", UcInvoiceExchangeRateEditor);
